import Column from "@amzn/meridian/esm/components/column";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import LearnMoreLink from "../../../../components/LearnMoreLink";

/**
 * Component that displays an indicator when AIMS status is set to "summary to organizer"
 * meaning only the organizer will receive the meeting summary.
 */
const OrganizerOnlyIndicator = () => {
  return (
  <Column spacing="none">
    <Row width="100%" spacing="none" spacingInset="none">
      <Column width="72px"/>
      <Column spacing="none" width="226px">
        <Row alignmentHorizontal="start">
          <Text type="h50" color="secondary">
            Meeting information unavailable
          </Text>
        </Row>
        <Column height="16px"/>
        <Row alignmentHorizontal="start">
          <Text type="b200" alignment="start" color="secondary">
            Only you will receive the meeting summary when it's ready.
          </Text>
        </Row>
        <Column height="16px"/>
        <Row alignmentHorizontal="start">
          <LearnMoreLink />
        </Row>
      </Column>
    </Row>
  </Column>
  );
};

export default OrganizerOnlyIndicator;
